<div class="side-nav-layout">
  <nav class="side-nav-layout__nav">
    <ng-content select="twaice-fe-side-nav"></ng-content>
  </nav>
  <div class="side-nav-layout__content">
    <ng-content></ng-content>
  </div>
</div>
